import { updateTitle } from "../actions";

const editTitle = (todoId, updatedTitle) => {
    return async (dispatch) => {
        const response = await fetch(
            `https://redux-todo-app-lws.herokuapp.com/todos/${todoId}`,
            {
                method: "PATCH",
                body: JSON.stringify({
                    text: updatedTitle,
                }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                },
            }
        );
        const todo = await response.json();

        dispatch(updateTitle(todo.id, todo.text));
    };
};

export default editTitle;
